/* eslint-disable */
import React from 'react';

import PropTypes from 'prop-types';
import * as cn from 'classnames';

import { Text, Button } from 'modules/common';

export const StackedCardWrapper = ({
  children,
  className,
  isInsideAccordion,
}) => {
  return (
    <div
      className={cn('bg-primitive-white', className, {
        'stacked-card-accordion': isInsideAccordion,
        'stacked-card': !isInsideAccordion,
      })}
    >
      {children}
    </div>
  );
};

StackedCardWrapper.defaultProps = {
  children: false,
  className: '',
  isInsideAccordion: null,
};

StackedCardWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  className: PropTypes.string,
  isInsideAccordion: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

function Card({
  title,
  description,
  children,
  footer,
  width,
  className,
  withChildrenPadding,
  withChildrenBorder,
  withButton,
  buttonProps,
  withCardBorder,
  withCardPadding,
  isInsideAccordion,
  withPaddingBottom,
  withTitleContainer,
  disabled,
  childrenClassName,
  trailingItem,
  titleTextProps,
  withFooter,
}) {
  if (isInsideAccordion) {
    withCardBorder = false;
    withCardPadding = false;
  }

  const tableProps = {
    thClassName: 'first:pl-ds-24 last:pr-ds-24',
    tdClassName: 'first:pl-ds-24 last:pr-ds-24',
    withRounded: withChildrenPadding,
    withChildrenBorder: withChildrenPadding,
  };

  return (
    <div
      className={cn(
        'bg-primitive-white rounded space-y-ds-16 ds-card',
        className,
        {
          'p-ds-24': withCardPadding,
          '!pb-0': !withPaddingBottom,
          'border border-default': withCardBorder,
          'opacity-40 cursor-not-allowed': disabled,
        }
      )}
      style={{
        width,
      }}
    >
      {withTitleContainer && (
        <div className="flex items-center gap-ds-8">
          <div className="flex flex-col gap-ds-4 flex-1">
            {title && (
              <Text type="subheading" weight="semibold" {...titleTextProps}>
                {title}
              </Text>
            )}

            {description && (
              <Text type="caption" color="muted">
                {description}
              </Text>
            )}
          </div>

          {trailingItem ? (
            trailingItem
          ) : (
            <>{withButton && <Button size="sm" {...buttonProps} />}</>
          )}
        </div>
      )}

      {children && (
        <div
          className={cn('flex flex-col gap-ds-16', childrenClassName, {
            '-mx-ds-24': !withChildrenPadding,
            'border-t': withChildrenBorder,
            'border-b': withChildrenBorder && (withFooter || footer),
          })}
        >
          {typeof children === 'function' ? children({ tableProps }) : children}
        </div>
      )}

      {footer && withFooter && <div>{footer}</div>}
    </div>
  );
}

Card.defaultProps = {
  title: '',
  description: '',
  children: false,
  footer: false,
  width: 'auto',
  className: '',
  childrenClassName: '',
  withChildrenPadding: true,
  withCardBorder: true,
  withChildrenBorder: false,
  withButton: false,
  isInsideAccordion: false,
  buttonProps: {},
  withCardPadding: true,
  withPaddingBottom: true,
  trailingItem: false,
  withTitleContainer: true,
  disabled: false,
  withFooter: false,
  titleTextProps: {},
};

Card.propTypes = {
  withButton: PropTypes.bool,
  disabled: PropTypes.bool,
  isInsideAccordion: PropTypes.bool,
  withFooter: PropTypes.bool,
  buttonProps: PropTypes.instanceOf(Object),
  titleTextProps: PropTypes.instanceOf(Object),
  title: PropTypes.string,
  childrenClassName: PropTypes.string,
  withChildrenPadding: PropTypes.bool,
  withCardPadding: PropTypes.bool,
  withCardBorder: PropTypes.bool,
  withPaddingBottom: PropTypes.bool,
  withTitleContainer: PropTypes.bool,
  withChildrenBorder: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Object),
  ]),
  trailingItem: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.bool,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  footer: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]),
  width: PropTypes.string,
};

export default Card;
